const MAX_SAMPLE_SIZE = 300;

const getPerfStore = () => {
  if (typeof window === "undefined") {
    return {
      marks: {},
      samples: [],
      counters: {},
      lastUpdatedAt: Date.now(),
    };
  }

  if (!window.__mooPerfStore) {
    window.__mooPerfStore = {
      marks: {},
      samples: [],
      counters: {},
      lastUpdatedAt: Date.now(),
    };
  }

  return window.__mooPerfStore;
};

export const markPerf = (name, meta = {}) => {
  const store = getPerfStore();
  store.marks[name] = {
    at: Date.now(),
    now: typeof performance !== "undefined" ? performance.now() : 0,
    meta,
  };
  store.lastUpdatedAt = Date.now();
};

export const recordPerfMetric = (name, value, meta = {}) => {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return;

  const store = getPerfStore();
  store.samples.push({
    name,
    value: numericValue,
    at: Date.now(),
    meta,
  });
  if (store.samples.length > MAX_SAMPLE_SIZE) {
    store.samples.splice(0, store.samples.length - MAX_SAMPLE_SIZE);
  }
  store.lastUpdatedAt = Date.now();
};

export const incrementPerfCounter = (name, amount = 1) => {
  const store = getPerfStore();
  const current = Number(store.counters[name] || 0);
  store.counters[name] = current + amount;
  store.lastUpdatedAt = Date.now();
};

export const startPerfTimer = (name, baseMeta = {}) => {
  const start =
    typeof performance !== "undefined" ? performance.now() : Date.now();
  return (endMeta = {}) => {
    const end =
      typeof performance !== "undefined" ? performance.now() : Date.now();
    const duration = end - start;
    recordPerfMetric(name, duration, {
      ...baseMeta,
      ...endMeta,
    });
    return duration;
  };
};

